import Script from 'next/script';
export function YotpoScript() {
    return (
        <Script
            id="Yotpo"
            type="text/javascript"
            strategy="lazyOnload"
            src="https://cdn-widgetsrepository.yotpo.com/v1/loader/mPsE4vXKaq2SbFLNe97Us9Gj3Mn5jQyH85l461fT"
        />
    );
}
